define('views/wellness/account',[
    'backbone',
    'views/_base/baseview',
    'text!views/wellness/account.html',
    'views/wellness/activity'
], function(Backbone, BaseView, Template, ActivityComponent){
    'use strict';

    return BaseView.extend({
        tagName : 'li',
        isRender: true,
        template: _.template(Template),
        events  : {
            'click .js-wellness-account-header' : 'toggleActivityList'
        },
        initialize: function(options){
            options = options || {};
            
            this.elementName = options.elementName;

            this.account = (options.data) ? options.data : {};

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.addAccountTitle();

            this.calculateEarning();

            this.$el.addClass(pf.getContent('wellness.content.accounts.class')).html(this.template());

            return this;
        },

        loadData: function(){

            var activities = this.account.activities;

            if(_.isArray(activities)){

                for(var i = 0; i < activities.length; i++){
                    var data = activities[i],
                        activity = new ActivityComponent({ data: data });
                    
                    this.$('.js-wellness-account-activity-list').append(activity.el);
                }

            }

        },

        calculateEarning: function(){

            if(this.account.total_earned){
                this.account.earned = formatCurrency(this.account.total_earned);
            } else {
                this.account.earned = '0.00';
            }

        },

        addAccountTitle: function(){
            
            if(this.account.is_primary){
                var title_text = pf.getContent('wellness.content.accounts.primary.header');
            } else {
                var title_text = pf.getContent('wellness.content.accounts.dependent.header');
            }

            this.account.title = title_text;
        },

        toggleActivityList: function(e){
            if(e && e.preventDefault){ e.preventDefault(); }
            if(e && e.stopPropagation){ e.stopPropagation(); }

            // console.log('showPartnerResource',this, $(e.currentTarget));

            var header = $(e.currentTarget),
                btn = header.find('.js-wellness-account-header-toggle'),
                list = header.parent().find('.js-wellness-account-activity-list-container');

            if(list.hasClass('closed')){
                list.removeClass('closed');
                btn.removeClass('closed');
            } else {
                list.addClass('closed');
                btn.addClass('closed');
            }

        },

        close: function(){}
    });
});

